export { default as LinkedInIcon } from '@assets/icons/socialIcons/linked-in.svg';
export { default as MediumIcon } from '@assets/icons/socialIcons/medium.svg';
export { default as TelegramIcon } from '@assets/icons/socialIcons/telegram.svg';
export { default as XIcon } from '@assets/icons/socialIcons/x.svg';
